//import TextBookFindSimpleListArea from "@/pages/comp/book_order/textbook/common/find_simple";
import { useState, useRef, useEffect } from 'react';
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import strFunc from '@/lib/lyg/string';
import { useSelector, useDispatch } from 'react-redux';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import ViewCGWordArrPopup from "@/pages/comp/book_order/textbook/popup/view_cg_word_arr";
import getXcolumnJson from "./xcolumn/list";
import SearchArea from "@/pages/comp/book_order/textbook/common/list/area/search";
import ManageBtnArea from "./area/manage_btn";

function TextBookFindSimpleListArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    listOpt: {},
    is_req_order: true,
    xcolumn_show_key_arr: [],
    xcolumn_unshow_key_arr: [],
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const ListComponentRef = useRef<any>(null);
  const listOptRef = useRef<any>({});
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    select_seq: "",
    s_title_like: "",
    s_subject: "",
    s_use_sort: "",
    s_category_seq: "",
    s_sort1_seq: "",
    s_sort2_seq: "",
    s_sort3_seq: "",
    s_is_able_order: "1",
    s_addon_textbook_sort: "1",
    s_addon_section: "1",
    s_addon_study: "1",
    s_addon_product: "1",
    s_addon_study_word: "",
    ...myProps.listOpt
  });
  listOptRef.current = listOpt;
  const [infoArr, setInfoArr] = useState([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [is_order_online, set_is_order_online] = useState(false);

  let xcolumn_show_key_arr: any = [...myProps.xcolumn_show_key_arr];
  let xcolumn_unshow_key_arr: any = [...myProps.xcolumn_unshow_key_arr];
  if (myProps.is_req_order) {
    xcolumn_show_key_arr = [
      ...xcolumn_show_key_arr,
      "row_view_stock_cnt",
      "row_view_price",
      // "row_view_price_use"
    ];
  }

  for (let i = 0; i < xColumnArr.x_column_list_arr.length; i++) {
    let col = xColumnArr.x_column_list_arr[i];
    if (strFunc.str_in_array(col.key, xcolumn_show_key_arr) != -1) {
      xColumnArr.x_column_list_arr[i].is_show = "1";
    }
    if (strFunc.str_in_array(col.key, xcolumn_unshow_key_arr) != -1) {
      xColumnArr.x_column_list_arr[i].is_show = "";
    }
  }

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "view_cg_word_arr",
    cg_word_pri_val_arr: [],
    voice: "",
    title: "팝업",
    width: "800px",
    height: "90%",
  });

  useEffect(() => {
    list({});
  }, [user]);

  const list = (inOptObj: any) => {
    let tmp_list_opt = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(tmp_list_opt);

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/textbook/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if (ListComponentRef.current) {
            ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
          }
        } else {

        }
      });
  };

  const select_finish = (inData: any) => {
    let selected_rows = ListComponentRef.current.getSelectedRows();
    let opt_obj = {
      selected_rows: selected_rows,
      ...inData
    };
    selected_rows = opt_obj.selected_rows;
    if (selected_rows.length == 0) {
      alert("선택된 교재가 없습니다.");
      return;
    }

    let online_textbook_cnt_json={
      textbook:0,
      online:0,
    };
    
    //선택검사
    for (let i = 0; i < selected_rows.length; i++) {
      let row = selected_rows[i];
      if(strFunc.is_empty(row["a_is_book"])&&row["a_is_online"]=="1"){
        online_textbook_cnt_json.online+=1;
      }else if(row["a_is_book"]=="1"){
        online_textbook_cnt_json.textbook+=1;
      }
    }
    let row_is_order_online=false;
    if(online_textbook_cnt_json.online>0 && online_textbook_cnt_json.textbook==0){
      row_is_order_online=true;
    }
    if(online_textbook_cnt_json.online==0&&online_textbook_cnt_json.textbook==0){
      alert("주문 가능한 교재가 선택되지 않았습니다.");
      return;
    }

    myProps.callbackData({
      info_arr: selected_rows,
      is_order_online: row_is_order_online,
    });
    myProps.closePopup();
  };

  const open_cg_word_arr_popup = (inData: any) => {
    let opt_obj = {
      cg_word_arr: [],
      voice: "",
      ...inData
    };

    let popup_sort = "cg_word_arr";
    let cg_word_pri_val_arr: any = [];
    for (let i = 0; i < opt_obj.cg_word_arr.length; i++) {
      let cg_word_item = opt_obj.cg_word_arr[i];
      cg_word_pri_val_arr.push(cg_word_item.row_pri_val);
    }

    if (cg_word_pri_val_arr.length == 0) {
      return false;
    }

    setPopupData({
      ...popupData,
      cg_word_pri_val_arr: cg_word_pri_val_arr,
      isOpen: true,
      sort: popup_sort,
      title: "단어보기",
    });
  };

  const rowOnClick = (rowData: any, idx: number, e: any, key: string) => {

  };

  const customCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "origin_val":origin_val,
    }
    */
    if (params.key === "row_view_sort1") {
      if (params.rowData.bsort1_title) {
        params.value = (
          <input type='text' value={params.rowData.bsort1_title} name="bsort1_title"
            onChange={(e: any) => { }} title={params.rowData.bsort1_title}
            style={{ width: "99%", border: 0, background: "transparent" }} />
        );
      }
    } else if (params.key === "row_view_sort2") {
      if (params.rowData.bsort2_title) {
        params.value = (
          <input type='text' value={params.rowData.bsort2_title} name="bsort2_title"
            onChange={(e: any) => { }} title={params.rowData.bsort2_title}
            style={{ width: "99%", border: 0, background: "transparent" }} />
        );
      }
    } else if (params.key === "row_view_sort3") {
      if (params.rowData.bsort3_title) {
        params.value = (
          <input type='text' value={params.rowData.bsort3_title} name="bsort3_title"
            onChange={(e: any) => { }} title={params.rowData.bsort3_title}
            style={{ width: "99%", border: 0, background: "transparent" }} />
        );
      }
    } else if (params.key === "row_view_category") {
      if (params.rowData.bcategory_title) {
        params.value = (
          <input type='text' value={params.rowData.bcategory_title} name="bcategory_title"
            onChange={(e: any) => { }} title={params.rowData.bcategory_title}
            style={{ width: "99%", border: 0, background: "transparent" }} />
        );
      }
    } else if (params.key === "row_view_stock_cnt") {
      if (params.rowData.product_info) {
        params.value = strFunc.comma(params.rowData.product_info.a_stock_cnt);
      }
    } else if (params.key === "row_view_price") {
      if (params.rowData.product_info && params.rowData.a_is_book == "1") {
        let sum_price = parseInt(strFunc.uncomma(params.rowData.product_info.a_price));
        sum_price += parseInt(strFunc.uncomma(params.rowData.product_info.a_price_tax));

        params.value = strFunc.comma(sum_price);
      }
      if (params.rowData.a_is_book != "1") {
        params.value = "-";
      }

      if (strFunc.is_empty(params.rowData.a_is_book) && params.rowData.a_is_online == "1") {
        if (params.rowData.product_info_use) {
          let sum_price = parseInt(strFunc.uncomma(params.rowData.product_info_use.a_price));
          sum_price += parseInt(strFunc.uncomma(params.rowData.product_info_use.a_price_tax));

          params.value = strFunc.comma(sum_price);
          params.value+= " (온라인)";
        }
      }
    } else if (params.key == "row_view_price_use" && params.rowData.a_is_online == "1") {
      if (params.rowData.product_info_use) {
        let sum_price = parseInt(strFunc.uncomma(params.rowData.product_info_use.a_price));
        sum_price += parseInt(strFunc.uncomma(params.rowData.product_info_use.a_price_tax));

        params.value = strFunc.comma(sum_price);
      }
      if (params.rowData.a_is_online != "1") {
        params.value = "-";
      }
    } else if (params.key == "row_view_word_count") {
      let word_tot_cnt = 0;
      if (params.rowData.study_arr) {
        let tmp_cg_word_arr: any = [];
        let tmp_mp3_voice = "";
        if (params.rowData.bcategory_title == "Voca9단계") {
          tmp_mp3_voice = "coolen";
        }
        for (let s_i = 0; s_i < params.rowData.study_arr.length; s_i++) {
          let study_item = params.rowData.study_arr[s_i];
          if (study_item.cg_word_arr) {
            word_tot_cnt += study_item.cg_word_arr.length;
            tmp_cg_word_arr = [
              ...tmp_cg_word_arr,
              ...study_item.cg_word_arr
            ];
          }
        }
        params.value = strFunc.comma(word_tot_cnt);

        params.value = (
          <a onClick={() => {
            open_cg_word_arr_popup({
              cg_word_arr: tmp_cg_word_arr,
              voice: tmp_mp3_voice,
            });
          }}>
            {params.value}
          </a>
        );
      }
    }

    return params.value;
  };

  return (
    <div>
      <SearchArea
        listOpt={listOpt}
        setListOpt={setListOpt}
        list={list}
      ></SearchArea>
      <ManageBtnArea
        select_finish={select_finish}
        is_order_online={is_order_online}
        set_is_order_online={set_is_order_online}
        is_req_order={myProps.is_req_order}
      ></ManageBtnArea>
      <div className="mt-1">
        <ListComponent
          ref={ListComponentRef}
          xColumnArr={{ ...xColumnArr }}
          gridOpt={{
            fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
            is_add_idx_num: false,
            is_add_checkbox: true,
            td_align: "center",
            height: "auto",
            is_fix_width: true,
            rowMultiSelectWithClick: false,
            onGridReady: () => {

            },

            is_all_select_row_key: true,
            rowOnClick: rowOnClick,
            customCellRenderer: customCellRenderer,
            class_name_json: {
              table_div: "basic_list_div",
              td_div: "row-col-div",
              input_check: "chk_row",
              row_input: "row-input",
              data_row_tr: "data_row_tr",
              active_row: "active",
              empty_con_div: "list_empty_content_div",
            },
          }}
        ></ListComponent>
      </div>
      <Paging now_page={listOpt.now_page}
        num_per_page={listOpt.num_per_page}
        total_rec={countInfo.tot}
        onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
        is_view_num_per_page={true}
        is_show_total_rec={true}
        onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>

      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "cg_word_arr" &&
            <ViewCGWordArrPopup
              cg_word_pri_val_arr={popupData.cg_word_pri_val_arr}
              voice={popupData.voice}
              callbackData={(inData: any) => { }}
              refreshData={(inData: any) => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></ViewCGWordArrPopup>
          }
        </LayerPopup>
      }
    </div>
  );
};
export default TextBookFindSimpleListArea;